import { render, staticRenderFns } from "./StaticDataDemo.vue?vue&type=template&id=94264138&"
import script from "./StaticDataDemo.vue?vue&type=script&lang=js&"
export * from "./StaticDataDemo.vue?vue&type=script&lang=js&"
import style0 from "./StaticDataDemo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports